import { SgdfSpinner } from './Spinner.js';
window.customElements.define('sgdf-spinner', SgdfSpinner);
//# sourceMappingURL=sgdf-spinner.js.map